import type {
  PreviewFacts,
  PreviewCopy,
  PreviewMarqueeItem,
} from "./preview-copy.types";
import { item } from "./preview-marquee";
export function derivedItems(f: PreviewFacts): PreviewMarqueeItem[] {
  return [cadenceItem(f), seatsItem(f)].filter((i) => i !== null);
}
function seatsItem(f: PreviewFacts): PreviewMarqueeItem | null {
  return f.seats
    ? item({
        mark: "people",
        label: `${f.seats} SEATS PER EPISODE`,
      })
    : null;
}
function cadenceItem(f: PreviewFacts): PreviewMarqueeItem | null {
  if (!f.roundMinutes) return null;

  const m = f.roundMinutes;
  const label =
    m % 1440 === 0
      ? m === 1440
        ? "A ROUND EVERY DAY"
        : `A ROUND EVERY ${m / 1440} DAYS`
      : m % 60 === 0
        ? `ROUNDS EVERY ${m / 60} ${m === 60 ? "HOUR" : "HOURS"}`
        : `ROUNDS EVERY ${m} MIN`;
  return item({
    mark: "hare",
    label,
  });
}
function cadenceWords({
  roundMinutes,
  minuteUnit,
}: {
  roundMinutes: number;
  minuteUnit: "minutes" | "min";
}): string {
  const m = roundMinutes;

  if (m % 10080 === 0) {
    const weeks = m / 10080;
    return weeks === 1 ? "every week" : `every ${weeks} weeks`;
  }

  if (m % 1440 === 0) {
    const days = m / 1440;
    return days === 1 ? "every day" : `every ${days} days`;
  }

  if (m % 60 === 0) {
    const hours = m / 60;
    return hours === 1 ? "every hour" : `every ${hours} hours`;
  }

  return `every ${m} ${minuteUnit}`;
}
export function cadenceOf(
  roundMinutes: number | null,
): Pick<PreviewCopy, "cadencePhrase" | "cadenceShort"> {
  return roundMinutes
    ? {
        cadencePhrase: cadenceWords({
          roundMinutes,
          minuteUnit: "minutes",
        }),
        cadenceShort: cadenceWords({
          roundMinutes,
          minuteUnit: "min",
        }),
      }
    : { cadencePhrase: null, cadenceShort: null };
}
